import { render, staticRenderFns } from "./ringkasanMaklumatIsiRumah.vue?vue&type=template&id=7037982c"
import script from "./ringkasanMaklumatIsiRumah.vue?vue&type=script&lang=js"
export * from "./ringkasanMaklumatIsiRumah.vue?vue&type=script&lang=js"
import style0 from "./ringkasanMaklumatIsiRumah.vue?vue&type=style&index=0&id=7037982c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports